import React, { useEffect, useState } from "react";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerJurados } from "../components/BannerJurados";
import { TextoInicialJurados } from "../components/TextoInicialJurados";
import { Footer } from "../../../components/Landing/Footer";
import { TextoinicialNumero } from "../components/TextoinicialNumero";
// styled components
import { Input, Avatar, Form, Button, Divider, Select} from "antd";
// hooks
import { useRegistrarjurado } from "../../../hooks/useRegistrarjurado";
// icons
import { UserOutlined } from "@ant-design/icons";
// data
import {
  TipoDocumentosOptions,
  SexoOptions,
  OrientacionSexualoOptions,
  EstratoOptions,
  IdentidadGeneroOptions,
  comunasOptions,
} from "../../../utils/dataSelectOptions";

import { useLocations } from "../../../hooks/useLocations";
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import { InputTexto } from "../../../components/Mascaras/InputTexto/InputTexto";
import { ModalDireccion } from "../../../components/ModalDireccion/ModalDireccion";
import apiLocation from "../../../api/Participantes/api.location";
import { Municipio } from "../../../models/LocationsModels/locations.models";
import { openNotification } from "../../../utils/Notifactions";
import DateInput from "../../../utils/DateInput";

export const RegistrarJurado = () => {
  const { Option } = Select;
  // state
  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
  } = UseVerConvocatorias();

  const {
    jurado,
    setJurado,
    guardarFoto,
    imageselected,
    fileImageRef,
    guardarFormulario,
    visibleFields,
    visibleFieldsPais,
    setVisibleFields,
    setVisibleFieldsPais,
    disabledInput,
    setDisabledInput,
    getUser,
    loading,
  } = useRegistrarjurado();

  useEffect(() => {
    getConvocatoriaPersistente();
    getUser();
  }, []);

  const [openModal, setOpenModal] = useState(false);

  const [municipios, setMunicipios] = useState<Municipio[]>([]);
  const handleDepartamento = async (id_departamento: string) => {

    setMunicipios([]);
    try {
      let nombreSeparado = id_departamento.split("-");

      setJurado({
        ...jurado,
        departamento_residencia: nombreSeparado[1],
      });
      localStorage.setItem("departamento", nombreSeparado[1]);
      const municipios = await apiLocation.obtenerMunicipios(nombreSeparado[0]);
      setMunicipios(municipios);
      setDisabledInput(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleMunicipio = async (nombreMunicipio: string) => {
    localStorage.setItem("ciudad", nombreMunicipio);
    try {
      if (nombreMunicipio === "MEDELLÍN") {
        setVisibleFields(true);
      } else {
        setVisibleFields(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [barrios, setBarrios] = useState([]);
  const handleComunas = async (id_comuna: string) => {
    localStorage.setItem("comuna", id_comuna);
    try {
      let nombreSeparado = id_comuna.split("-");

      setJurado({
        ...jurado,
        comuna_residencia: nombreSeparado[1],
      });

      const barrios = await apiLocation.obtenerBarrios(nombreSeparado[0]);
      setBarrios(barrios);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePais = (nombre_pais: string) => {
    localStorage.setItem("pais", nombre_pais);
    if (nombre_pais === "COLOMBIA") {
      setVisibleFieldsPais(true);
    } else {
      setJurado({
        ...jurado,
        departamento_residencia: "",
        municipio_residencia: "",
        comuna_residencia: "",
        barrio: "",
        pais_nacimiento: nombre_pais,
      });

      setVisibleFieldsPais(false);
      setVisibleFields(false);
      setDisabledInput(true);
    }
  };

  const limpiarNumeroDocumento = (event: any) => {
    let valor = event.target.value.replace(/\D/g, "");
    setJurado({ ...jurado, numero_documento: valor });
  };

  const limpiarNumeroCelular = (event: any) => {
    let valor = event.target.value.replace(/\D/g, "");
    setJurado({ ...jurado, telefono_celular: valor });
  };

  const limpiarNumeroTelefono = (event: any) => {
    let valor = event.target.value.replace(/\D/g, "");
    setJurado({ ...jurado, telefono_fijo: valor });
  };

  // campos
  const fields = [
    { name: "perfil", value: jurado.perfil },
    { name: "tipo_identificacion", value: jurado.tipo_identificacion },
    { name: "numero_documento", value: jurado.numero_documento },
    { name: "fecha_nacimiento", value: jurado.fecha_nacimiento },
    { name: "dia_nacimiento", value: jurado.dia_nacimiento },
    { name: "mes_nacimiento", value: jurado.mes_nacimiento },
    { name: "año_nacimiento", value: jurado.año_nacimiento },
    { name: "primer_nombre", value: jurado.primer_nombre },
    { name: "segundo_nombre", value: jurado.segundo_nombre },
    { name: "primer_apellido", value: jurado.primer_apellido },
    { name: "segundo_apellido", value: jurado.segundo_apellido },
    { name: "genero", value: jurado.genero },
    { name: "orientacion_sexual", value: jurado.orientacion_sexual },
    { name: "identidad_genero", value: jurado.identidad_genero },
    { name: "path_documento", value: jurado.path_documento },
    { name: "etnia", value: jurado.etnia },
    { name: "telefono_celular", value: jurado.telefono_celular },
    { name: "telefono_fijo", value: jurado.telefono_fijo },
    { name: "pais_nacimiento", value: jurado.pais_nacimiento },
    { name: "departamento_residencia", value: jurado.departamento_residencia },
    { name: "municipio_residencia", value: jurado.municipio_residencia },
    { name: "comuna_residencia", value: jurado.comuna_residencia },
    { name: "barrio", value: jurado.barrio },
    { name: "direccion", value: jurado.direccion },
    { name: "estrato", value: jurado.estrato },
    { name: "correo_electronico", value: jurado.correo_electronico },
  ];

  const { paises, departamentos } = useLocations();

  return (
    <div>
      <Header />
      <BannerJurados BannerText="Banco de Jurados" convocatorias={convocatoria}/>
      <div className="container-fluid2">
        <TextoInicialJurados
          TituloSpan="¡GENIAL! Estas a punto de postularte como jurado."
          TitulosinSpan="Por favor completa el formulario de hoja de vida. Recuerda diligenciar los campos obligatorios."
        />
      </div>
      <div className="container-fluid2">
        <div className="col-12 p-2">
          <div className="row">
            <TextoinicialNumero
              numero="1"
              textosinspan="Hoja de vida"
              textospan=""
              color="morado"
            />
          </div>
        </div>
      </div>

      <Form
        name="registrarjurado"
        size="large"
        fields={fields}
        onFinish={(values: any) => {
          localStorage.setItem("ciudad", values.municipio_residencia);
          localStorage.setItem("pais", values.pais_nacimiento);
          if (values.path_documento === "") {
            return openNotification({
              titulo: "Error",
              descripcion: "Falta adjuntar documento de identidad",
              placement: "bottomRight",
            });
          }
          return guardarFormulario();
        }}
        onFieldsChange={(_: any, fields: any) => {
          let infoupdate: any = { ...jurado };
          infoupdate[_[0].name[0]] = _[0].value;
          setJurado(infoupdate);
        }}
      >
        <div className="container-fluid2">
          <div className="row pe-0">
            <div className="col-12 col-md-6 col-lg-4 mt-4">
              <div className="row">
                <span className="col-12 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                  Fotografía -{" "}
                  <span className="font-family-Montserrat-Regular font-size-10px">
                    &nbsp;Opcional
                  </span>
                </span>
                <div className="col-4 justify-content-center align-content-center align-items-center">
                  {jurado.path_foto === "" ? (
                    <Avatar
                      size={{
                        xs: 100,
                        sm: 100,
                        md: 100,
                        lg: 100,
                        xl: 100,
                        xxl: 100,
                      }}
                      icon={<UserOutlined />}
                    />
                  ) : (
                    <Avatar
                      size={{
                        xs: 100,
                        sm: 100,
                        md: 100,
                        lg: 100,
                        xl: 100,
                        xxl: 100,
                      }}
                      src={imageselected}
                    />
                  )}
                </div>
                <div
                  className="col-8"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Button
                    className="button-blanco-radius font-size-12px"
                    onClick={() => fileImageRef.current.click()}
                  >
                    Subir foto
                  </Button>
                  <input
                    ref={fileImageRef}
                    type="file"
                    hidden
                    onChange={(e) => {
                      guardarFoto(e);
                      e.target.value = "";
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-8 mt-4">
              <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Cuéntanos sobre ti ¿Cuál es tu perfil?
              </span>
              <Form.Item
                className="no-margin"
                name="perfil"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <Input.TextArea showCount maxLength={1000} />
              </Form.Item>
            </div>
            <div className="col-12 col-md-6 col-lg-6 mt-4">
              <div className="row g-2">
                <div className="col-6">
                  <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                    Tipo Identificación
                  </span>
                  <Form.Item
                    className="no-margin"
                    name="tipo_identificacion"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      placeholder="C.C."
                    >
                      {TipoDocumentosOptions.map(({ value, text }) => (
                        <Select.Option key={value} value={value}>
                          {text}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="col-6">
                  <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                    Documento
                  </span>
                  <Form.Item
                    className="no-margin"
                    name="numero_documento"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input
                      type="text"
                      onChange={(e) => limpiarNumeroDocumento(e)}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6 mt-4">
              <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Fecha de nacimiento
              </span>
              <Form.Item
                className="no-margin"
                name="fecha_nacimiento"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <DateInput
                  save={(fecha) => {
                    setJurado({
                      ...jurado,
                      fecha_nacimiento: fecha,
                    });
                  }}
                  dia={jurado.fecha_nacimiento?.split("-")[2] || ""}
                  mes={jurado.fecha_nacimiento?.split("-")[1] || ""}
                  anio={jurado.fecha_nacimiento?.split("-")[0] || ""}
                />
              </Form.Item>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Primer nombre
              </span>
              <div className="row">
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="primer_nombre"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    {/* <Input /> */}
                    <InputTexto
                      maxLength={100}
                      name="primer_nombre"
                      texto={jurado.primer_nombre}
                      setTexto={setJurado}
                      alltexto={jurado}
                      onInput={jurado.primer_nombre}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Segundo nombre -{" "}
                <span className="font-family-Montserrat-Regular font-size-10px">
                  &nbsp;Opcional
                </span>
              </span>
              <div>
                <div className="col-12">
                  <Form.Item className="no-margin" name="segundo_nombre">
                    <InputTexto
                      maxLength={100}
                      name="segundo_nombre"
                      texto={jurado.segundo_nombre}
                      setTexto={setJurado}
                      alltexto={jurado}
                      onInput={jurado.segundo_nombre}
                    />
                    {/* <Input /> */}
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Primer apellido
              </span>
              <div>
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="primer_apellido"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <InputTexto
                      maxLength={100}
                      name="primer_apellido"
                      texto={jurado.primer_apellido}
                      setTexto={setJurado}
                      alltexto={jurado}
                      onInput={jurado.primer_apellido}
                    />
                    {/* <Input /> */}
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Segundo apellido -{" "}
                <span className="font-family-Montserrat-Regular font-size-10px">
                  &nbsp;Opcional
                </span>
              </span>
              <div className="row">
                <div className="col-12">
                  <Form.Item className="no-margin" name="segundo_apellido">
                    <InputTexto
                      maxLength={100}
                      name="segundo_apellido"
                      texto={jurado.segundo_apellido}
                      setTexto={setJurado}
                      alltexto={jurado}
                      onInput={jurado.segundo_apellido}
                    />
                    {/* <Input /> */}
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Identidad de género
              </span>
              <div className="row">
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="genero"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Seleccionar..."
                    >
                      {SexoOptions.map(({ value, text }) => (
                        <Select.Option key={value} value={value}>
                          {text}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Orientación sexual
              </span>
              <div className="row">
                <div className="col-12">
                  <Form.Item className="no-margin" name="orientacion_sexual" rules={[{ required: true, message: "Campo obligatorio" }]}>
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Seleccionar..."
                    >
                      {OrientacionSexualoOptions.map(({ value, text }) => (
                        <Select.Option key={value} value={text}>
                          {text}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Discapacidad
              </span>
              <div>
                <div className="col-12">
                  <Form.Item className="no-margin" name="identidad_genero" rules={[{ required: true, message: "Campo obligatorio" }]}>
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Seleccionar..."
                    >
                      {IdentidadGeneroOptions.map(({ value, text }) => (
                        <Select.Option key={value} value={text}>
                          {text}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Etnia
              </span>
              <Form.Item
                className="no-margin"
                name="etnia"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <Select style={{ width: "100%" }} placeholder="Seleccionar...">
                  <Option value="Indigena">Indígena</Option>
                  <Option value="Gitano o Rrom">Gitano(a) o Rrom</Option>
                  <Option value="Raizal">Raizal</Option>
                  <Option value="Palenquero">Palenquero</Option>
                  <Option value="Negro">Negro, mulato, afrodescendiente, afrocolombiano</Option>
                  <Option value="Ninguno">Ningún grupo étnico</Option>
                </Select>
              </Form.Item>
            </div>
            <div className="col-12 col-md-6 col-lg-6 mt-4">
              {/*<span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Documento cargado en convocatorias anteriores:
              </span>
              <Form.Item
                className="no-margin"
                name="path_documento"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
              <DocumentInput
                doc={jurado.path_documento}
                fileInputRef={fileInputRef}
                ancho_btn={30}
                on_change={(e) => {
                  guardarArchivo(e);
                  e.target.value = "";
                }}
                onDelete={() => {
                  setJurado({
                    ...jurado,
                    path_documento: "",
                  });
                }}
              />
              </Form.Item>

               <Form.Item className="no-margin" name="path_documento" rules={[{ required: true, message: "Documento obligatorio" }]}>
                <Input.Group compact>
                  <Input className="input-form-adjuntar" style={{ width: "70%"}} value={jurado.path_documento} disabled={true} />
                  <Button className="no-margin buttonblanco-radius-input" style={{ width: "30%"}} onClick={() => fileInputRef.current.click()}>
                    Adjuntar
                  </Button>
                  <input ref={fileInputRef} type="file" hidden onChange={(e) => {
                    guardarArchivo(e);
                    e.target.value = ""
                  }} />
                </Input.Group>
              </Form.Item> */}
            </div>

            <div className="col-12 mt-5 font-family-Montserrat-Bold font-size-14px">
              <span>Información de contacto</span>
            </div>
            <Divider style={{ marginTop: "20px" }} />
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Celular
              </span>
              <div className="row">
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="telefono_celular"
                    rules={[
                      { required: true, message: "Campo obligatorio" },
                      { min: 7, message: "Mínimo 7 números" },
                      { max: 10, message: "Máximo 10 números" },
                    ]}
                  >
                    <Input
                      type="text"
                      maxLength={10}
                      onChange={(e) => limpiarNumeroCelular(e)}
                    />
                    {/* <InputNumero disabled={false} name="telefono_celular" texto={jurado.telefono_celular} setTexto={setJurado} alltexto={jurado} /> */}
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Teléfono fijo -{" "}
                <span className="font-family-Montserrat-Regular font-size-10px">
                  &nbsp;Opcional
                </span>
              </span>
              <div className="row">
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="telefono_fijo"
                    rules={[
                      { min: 7, message: "Mínimo 7 números" },
                      { max: 10, message: "Máximo 10 números" },
                    ]}
                  >
                    <Input
                      type="text"
                      maxLength={10}
                      onChange={(e) => limpiarNumeroTelefono(e)}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                País de nacimiento
              </span>
              <div className="row">
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="pais_nacimiento"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Select
                      showSearch
                      style={{ width: "100%" }}
                      placeholder="Seleccionar..."
                      onChange={handlePais}
                    >
                      {paises.map(({ id, nombre }) => (
                        <Select.Option key={id} value={nombre}>
                          {nombre}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </div>
            {visibleFieldsPais && (
              <div className="col-12 col-md-6 col-lg-3 mt-4">
                <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                  Departamento de residencia
                </span>
                <div className="row">
                  <div className="col-12">
                    <Form.Item
                      className="no-margin"
                      name="departamento_residencia"
                      rules={[
                        jurado.pais_nacimiento === "COLOMBIA"
                          ? { required: true, message: "Campo obligatorio" }
                          : {},
                      ]}
                    >
                      <Select
                        // showSearch
                        // filterOption={(input, option: any) =>
                        //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        // }
                        // filterSort={(optionA, optionB) =>
                        //   optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        // }
                        placeholder="Seleccionar..."
                        onChange={handleDepartamento}
                      >
                        {departamentos.map(({ id, nombre }) => (
                          <Select.Option key={id} value={`${id}-${nombre}`}>
                            {nombre}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              </div>
            )}
            {visibleFieldsPais && (
              <div className="col-12 col-md-6 col-lg-3 mt-4">
                <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                  Municipio de residencia
                </span>
                <div className="row">
                  <div className="col-12">
                    <Form.Item
                      className="no-margin"
                      name="municipio_residencia"
                      rules={[
                        jurado.pais_nacimiento === "COLOMBIA" &&
                        jurado.departamento_residencia !== ""
                          ? { required: true, message: "Campo obligatorio" }
                          : {},
                      ]}
                    >
                      <Select
                        disabled={disabledInput}
                        placeholder="Seleccionar..."
                        onChange={handleMunicipio}
                      >
                        {municipios.map(({ id, nombre }) => (
                          <Select.Option key={id} value={nombre}>
                            {nombre}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              </div>
            )}
            {visibleFields && (
              <div className="col-12 col-md-6 col-lg-3 mt-4">
                <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                  Comuna de residencia
                </span>
                <div className="row">
                  <div className="col-12">
                    <Form.Item className="no-margin" name="comuna_residencia" rules={[{ required: true, message: "Campo obligatorio" }]}>
                      <Select
                        style={{ width: "100%" }}
                        placeholder="Seleccionar..."
                        onChange={handleComunas} /* disabled={disabledInputs} */
                      >
                        {comunasOptions.map(({ key, value }) => (
                          <Select.Option key={key} value={`${key}-${value}`}>
                            {key} - {value}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              </div>
            )}
            {visibleFields && (
              <div className="col-12 col-md-6 col-lg-3 mt-4">
                <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                  Barrio de residencia
                </span>
                <div className="row">
                  <div className="col-12">
                    <Form.Item className="no-margin" name="barrio" rules={[{ required: true, message: "Campo obligatorio" }]}>
                      <Select
                        style={{ width: "100%" }}
                        placeholder="Seleccionar..." /* disabled={disabledInputs} */
                      >
                        {barrios.map(({ id, nombre }) => (
                          <Select.Option key={id} value={nombre}>
                            {nombre}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              </div>
            )}
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Estrato
              </span>
              <div className="row">
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="estrato"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Seleccionar..."
                    >
                      {EstratoOptions.map(({ value, text }) => (
                        <Select.Option key={value} value={value}>
                          {text}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Dirección de residencia
              </span>
              <div className="row">
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="direccion"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input
                      maxLength={200}
                      readOnly
                      autoComplete="off"
                      onClick={() => setOpenModal(true)}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-6 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Correo electrónico
              </span>
              <div className="row">
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="correo_electronico"
                    rules={[
                      { required: true, message: "Campo obligatorio" },
                      { type: "email", message: "No es un correo válido" },
                    ]}
                  >
                    <Input maxLength={100} />
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
      <div
        className="container-fluid2 bg-white"
        style={{
          justifyContent: "center",
          marginTop: "0.5%",
          position: "sticky",
          bottom: 0,
          paddingBottom: "0%",
        }}
      >
        <div className="col justify-content-flex-end">
          <Button
            type="link"
            htmlType="submit"
            form="registrarjurado"
            className="button-azul-radius font-size-12px"
            disabled={loading}
          >
            Continuar
            {loading && (
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
              />
            )}
          </Button>
        </div>
      </div>
      <Footer />
      <ModalDireccion
        modal={openModal}
        CancelarModal={() => setOpenModal(false)}
        AceptarModal={() => setOpenModal(false)}
        directions={jurado}
        setDireccion={setJurado}
        namedirections="direccion"
      />
    </div>
  );
};
